var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { parseBoolean, useGlobalContext } from '@honeycomb/data';
import { Skeleton2, Stacker, StarRating } from '@honeycomb/ui-core';
import { TripadvisorRating } from '../../tripadvisor/TripadvisorRating';
import { HotelCustomerRating } from '../HotelCustomerRating/HotelCustomerRating';
export function HotelRatings(_a) {
    var { hotel, onDialogTriggerClick } = _a, other = __rest(_a, ["hotel", "onDialogTriggerClick"]);
    const { configSettings: { ShowInternalCustomerScore }, } = useGlobalContext();
    const loading = !hotel;
    const { estabId, starRating, customerFeedback, tripadvisorFeedback } = hotel || {};
    const hasCustomerFeedback = customerFeedback && (customerFeedback.overallRating || 0) > 0;
    const handleReviewDialogTriggerClick = React.useCallback((origin) => (_event) => {
        onDialogTriggerClick === null || onDialogTriggerClick === void 0 ? void 0 : onDialogTriggerClick(origin);
    }, [onDialogTriggerClick]);
    // Star rating / Trip Advisor rating / Brand customer rating (these can wrap)
    return (React.createElement(Stacker, Object.assign({ columnSpacing: 4, rowSpacing: 2, direction: "row", alignItems: "center", flexWrap: "wrap" }, other), loading ? (React.createElement(React.Fragment, null,
        React.createElement(Skeleton2, { w: 80, h: "1em", variant: "text" }),
        React.createElement(Skeleton2, { w: 120, h: "1em", variant: "text" }))) : (React.createElement(React.Fragment, null,
        React.createElement(StarRating, { rating: starRating, "data-id": "star_rating", "data-key": estabId }),
        (tripadvisorFeedback === null || tripadvisorFeedback === void 0 ? void 0 : tripadvisorFeedback.numberOfReviews) && (React.createElement(TripadvisorRating, { tripadvisorFeedback: tripadvisorFeedback, onClick: handleReviewDialogTriggerClick('tripadvisor'), "data-id": "trip_advisor_rating", "data-key": estabId })),
        hasCustomerFeedback && parseBoolean(ShowInternalCustomerScore) && (React.createElement(HotelCustomerRating, { onClick: handleReviewDialogTriggerClick('customer'), overallRating: customerFeedback.overallRating || 0, overallRatingDescription: customerFeedback.overallRatingDescription || undefined, "data-id": "customer_rating", "data-key": estabId }))))));
}
